import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DateInput } from '@/kit/DatePickers/DateInput';
import { DateRangeCalendar } from '@/kit/DatePickers/calendar/DateRangeCalendar';
import { useOutsideClick } from '@/hooks/useOutsideClick';
import s from './index.module.scss';

export const DateRangePicker = ({
  range = [null, null],
  setRange,
  minDate,
  maxDate,
  hideCalendar,
}) => {
  const { t } = useTranslation('activity');
  const ref = useRef();
  const [open, setOpen] = useState(false);

  useOutsideClick(ref, () => setOpen(false), open);

  return (
    <div className={s.wrapper} ref={ref}>
      <div className="f-small-accent" style={{ color: '#17232D' }}>
        {t('date_picker.date_range')}
      </div>
      <div className={s.inputs}>
        <DateInput
          name="date_from"
          value={range[0]}
          onChange={date => setRange([date, range[1]])}
          onFocusIn={() => setOpen(true)}
          placeholder="dd.mm.yyyy"
        />
        <DateInput
          name="date_to"
          value={range[1]}
          onChange={date => setRange([range[0], date])}
          onFocusIn={() => setOpen(true)}
          placeholder="dd.mm.yyyy"
        />
      </div>
      {open && !hideCalendar && (
        <div className={s.calendar}>
          <DateRangeCalendar
            range={range}
            minDate={minDate}
            maxDate={maxDate}
            onRangeChange={range => {
              setRange(range);
              setOpen(false);
            }}
          />
        </div>
      )}
    </div>
  );
};
